
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/react-scheduler/accessibility",
      function () {
        return require("private-next-pages/x/react-scheduler/accessibility.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/react-scheduler/accessibility"])
      });
    }
  